import {
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import { typedObjectEntries } from "common/helpers/utils";
import type { Campaign } from "common/types";

import { MANAGE_CAMPAIGNS_ACTIONS } from "../../../constants";
import CampaignsActions from "./CampaignsActions";

import type { Dispatch, ReactNode, SetStateAction } from "react";

interface MobileDrawerProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
  selectedCampaigns: Campaign[];
  action: keyof typeof MANAGE_CAMPAIGNS_ACTIONS;
  setAction: Dispatch<SetStateAction<keyof typeof MANAGE_CAMPAIGNS_ACTIONS>>;
  onClose: () => void;
}

export default function MobileDrawer({
  isOpen,
  setIsOpen,
  children,
  selectedCampaigns,
  action,
  setAction,
  onClose,
}: MobileDrawerProps) {
  function resetAction() {
    setAction(undefined);
  }

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen} onAfterClose={resetAction}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent>
        {action ? (
          <CampaignsActions
            action={action}
            selectedCampaigns={selectedCampaigns}
            onBack={resetAction}
            onClose={onClose}
          />
        ) : (
          <>
            <DrawerTitle className="mb-3">Manage campaigns</DrawerTitle>

            {typedObjectEntries(MANAGE_CAMPAIGNS_ACTIONS).map(
              ([key, { icon: Icon, label }]) => (
                <button
                  key={key}
                  type="button"
                  className="px-2 py-3 last:pb-2 last flex items-center text-button-sm gap-x-1.5 border-b last:border-b-0 border-black-200"
                  onClick={() => setAction(key)}
                >
                  <Icon weight="fill" size={24} />
                  {label}
                </button>
              ),
            )}
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
